module.exports = __webpack_public_path__ + "static/electron-dd7cc3f396253aa98dacb97231f48a5d.png";